export enum actionTypes {
  CONTRATACIONES_FETCH = 'CONTRATACIONES_FETCH',
  CONTRATACIONES_SUCCESS = 'CONTRATACIONES_SUCCESS',
  CONTRATACIONES_ERROR = 'CONTRATACIONES_ERROR',
  CONTRATACIONES_RESET = 'CONTRATACIONES_RESET',
}

export enum ContratacionesStatus {
  Idle,
  Loading,
  Error,
  Success,
}

export interface Contratacion {
  id: number
  nombre: string
}

export interface ContratacionesState {
  status: ContratacionesStatus
  contrataciones: Array<Contratacion>
}

export interface ContratacionesFetch {
  type: typeof actionTypes.CONTRATACIONES_FETCH
}

export interface ContratacionesSuccess {
  type: typeof actionTypes.CONTRATACIONES_SUCCESS
  payload: { contrataciones }
}

export interface ContratacionesError {
  type: typeof actionTypes.CONTRATACIONES_ERROR
  payload: null
}

export interface ContratacionesReset {
  type: typeof actionTypes.CONTRATACIONES_RESET
  payload: null
}

export type ContratacionesActions = ContratacionesFetch | ContratacionesSuccess | ContratacionesError | ContratacionesReset

export const initialState: ContratacionesState = {
  status: ContratacionesStatus.Idle,
  contrataciones: [],
}
